import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Emoji } from '@evertel/web/emojis'
// evertel
import { APIDataReaction } from '@evertel/types'

interface ReactionProps {
    onSelect?: (reaction: APIDataReaction) => void
    emoji?: string
    count?: number
    isMyReaction?: boolean
    showClickAnimation?: boolean
}

const Reaction: React.FC<ReactionProps> = observer(({
    onSelect,
    emoji,
    count,
    isMyReaction,
    showClickAnimation = true
}) => {

    const [bounce, setBounce] = useState(false)

    const onClick = () => {
        if (onSelect) onSelect({
            text: emoji
        })

        setBounce(true)

        setTimeout(() => {
            setBounce(false)
        }, 750)
    }

    if (!emoji) return null

    return (
        <button
            className={classNames(
                'reaction',
                {
                    mine: isMyReaction,
                    bounce: bounce && showClickAnimation
                })}
            onClick={onClick}
        >
            <Emoji
                size={16}
                emoji={emoji}
                count={count}
            />
        </button>
    )
})

export { Reaction }
